import styled from 'styled-components'
const FormStyle = styled.form`
margin-bottom: 40px;
`
export  {FormStyle}